const defaultState = {
    accessGroup: {},
};

const mutations = {
    setAccessGroupState(state, accessGroup) {
        state.accessGroup = accessGroup;
    },
    resetAccessGroupState(state) {
        state.accessGroup = {};
    },
};

const actions = {
    async getAccessGroupInfo({ commit, dispatch }, accessGroupId) {
        try {
            const { data } = await this.$rq.getAccessGroup(accessGroupId, { showallattributes: true });
            commit('setAccessGroupState', data);
        } catch (err) {
            dispatch('resetAccessGroupInfo');
        }
    },
    resetAccessGroupInfo({ commit }) {
        commit('resetAccessGroupState');
    },
};

const getters = {
    accessGroup: state => state.accessGroup,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
